import { AxiosError } from 'axios';
import { t } from 'i18next';
import isString from 'lodash/isString';

import { BACKEND_ERROR_TEXT, FIREBASE_ERRORS_TEXTS } from '../config/constants';

type FirebaseError = Error & { code: string };

export const isFirebaseError = (e: unknown): e is FirebaseError =>
  e instanceof Error && e.name === 'FirebaseError' && 'code' in e && isString(e.code);

export const getErrorMessage = (e: unknown, defaultErrorMessage: string = BACKEND_ERROR_TEXT): string => {
  try {
    if (e instanceof AxiosError && e.response) {
      const { data } = e.response;

      if (data && 'message' in data) {
        return data.message;
      }

      // Backend envelope: { data: {}, errors: [{ name, description, errorCode }] }
      const [backendError] = Array.isArray(data?.errors) ? data.errors : [];

      return backendError?.description || backendError?.name || 'Unknown error';
    }

    if (e instanceof Error) {
      if (isFirebaseError(e)) {
        console.warn(`Firebase error with code = ${e.code}`);

        if (e.code in FIREBASE_ERRORS_TEXTS) {
          return t(FIREBASE_ERRORS_TEXTS[e.code] as any);
        }

        const firebaseMessage = e.message.replace('Firebase: ', '').replace(`(${e.code})`, '');

        return firebaseMessage === 'Error .' ? e.code : firebaseMessage;
      }

      return e.message;
    }

    return defaultErrorMessage;
  } catch (error) {
    return defaultErrorMessage;
  }
};

export class CancellationError extends Error {
  constructor(desc = 'Axios request') {
    super(`${desc} was cancelled`);
  }
}
